import React, { useState } from "react";
import Status from "../Components/Status";
import env, { normalPriceCount, rxFindCount } from "../../env";
import ErrorAction from "../../components/Modal/ErrorAction";
import PostReq from "../../utils/PostReq";

function FaqTableRow(props) {
  const [openOption, setOpenOption] = useState(0);
  const [checkState, setCheckState] = useState(false);
  const [DeletePop, setDeletePop] = useState(false);

  const activeAcc = props.index === props.detail;
  const item = props.item;
  const DeleteRow = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/document/delete-faq",
      body: { faqId: item._id },
    });
    if (result.success) window.location.reload();
  };
  return (
    <React.Fragment>
      <tr className={activeAcc ? "activeAccordion" : "accordion"}>
        <td>{item?.title}</td>

        <td>
          <div className="more-btn">
            <i
              className="tableIcon fas fa-edit"
              onClick={() => (window.location.href = "/faq/detail/" + item._id)}
            ></i>
            <i
              className="tableIcon fas fa-trash"
              style={{ color: "#ff0000" }}
              onClick={() => setDeletePop(item._id)}
            ></i>
          </div>
        </td>
      </tr>
      {DeletePop ? (
        <ErrorAction
          text={"آیا این سوال حذف شود؟"}
          buttonText={"حذف"}
          color={"red"}
          close={() => setDeletePop(false)}
          action={DeleteRow}
        />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
}
export default FaqTableRow;
